import { render, staticRenderFns } from "./MProductList.vue?vue&type=template&id=0c29da08&scoped=true"
import script from "./MProductList.vue?vue&type=script&lang=js"
export * from "./MProductList.vue?vue&type=script&lang=js"
import style0 from "./MProductList.vue?vue&type=style&index=0&id=0c29da08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c29da08",
  null
  
)

export default component.exports